// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const Interval = t.struct({
    actualHours: t.Number,
    beginDate: t.Number,
    completedDate: t.Number,
    endDate: t.Number,
    hoursLimit: t.Number,
    number: t.Number,
    status: t.String,
    type: t.String
}, {
    name: 'Interval',
    strict: true
});

export const getDefaultState = () => new Interval({
    actualHours: 0,
    beginDate: 0,
    completedDate: 0,
    endDate: 0,
    hoursLimit: 0,
    number: 0,
    status: '',
    type: ''
});

export default Interval;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/interval.js